import { render, staticRenderFns } from "./ContactBasic.vue?vue&type=template&id=44b58662&scoped=true"
import script from "./ContactBasic.vue?vue&type=script&lang=js"
export * from "./ContactBasic.vue?vue&type=script&lang=js"
import style0 from "./ContactBasic.vue?vue&type=style&index=0&id=44b58662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b58662",
  null
  
)

export default component.exports